import {nowString} from "./datetime-helpers";

class MeetingsApi {

    constructor(seamApi) {
        this.api = seamApi;
    }

    async getMeetingRooms(params) {
        return this.api.handleResponse(async  () => {
            const response = await this.api.get('/meeting-rooms/public', params );
            return response.data;
        });
    }

    async getMeetingRoom(id, params) {
        return this.api.handleResponse(async  () => {
            const response = await this.api.get(`/meeting-rooms/${id}`, params );
            return response.data;
        });
    }

    async getMeetingRoomQuote(params = {}) {
        return this.api.handleResponse(async () => {
            const response = await this.api.post('/meeting-room-bookings/public-quote', params)

            return response.data;
        })
    }

    async getCalendarAvailability(id, params) {

        return this.api.handleResponse(async () => {
            let response = await this.api.get(`/meeting-rooms/${id}/calendar-availability`, params );
            return response.data;
        });
    }

    async getCalendarDayAvailability(id, params) {

        return this.api.handleResponse(async () => {
            let response = await this.api.get(`/meeting-rooms/${id}/day-availability`, params );
            return response.data;
        });
    }
}


export default MeetingsApi;
